import React from 'react';
import { useFlexLayout } from 'react-table';
import { useHvTable, HvTableContainer } from '@hitachivantara/uikit-react-core';

import { DEFAULT_COLUMN } from '../../utils';

const AlarmTable = ({ columns, data, classPrefix }) => {
  const { getTableHeadProps, headerGroups, rows, prepareRow } = useHvTable(
    {
      columns,
      data,
      defaultColumn: DEFAULT_COLUMN,
    },
    useFlexLayout
  );

  return (
    <HvTableContainer className={`${classPrefix}-table-container`}>
      <div className={`${classPrefix}-table`}>
        <div
          {...getTableHeadProps?.()}
          className={`${classPrefix}-table-header`}
        >
          {headerGroups.map((headerGroup) => (
            <div
              {...headerGroup.getHeaderGroupProps()}
              key={headerGroup.id}
            >
              {headerGroup.headers.map((col) => (
                <div
                  {...col.getHeaderProps()}
                  key={col.id}
                  className={`${classPrefix}-header-cell`}
                >
                  {col.render('Header')}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className={`${classPrefix}-body`}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <div
                {...row.getRowProps()}
                key={row.id}
                className={`${classPrefix}-row`}
              >
                {row.cells.map((cell) => (
                  <div
                    {...cell.getCellProps()}
                    key={cell.column.id}
                    className={`${classPrefix}-cell`}
                  >
                    {cell.render('Cell')}
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </HvTableContainer>
  );
};

export default AlarmTable;
